import { requestMapping } from "./index";
import { generateUUID } from "@/utils/uuid";

const defaultConfig = {
  where: {
    field: "geom",
    op: "!=",
    value: null
  }
};

export const getRequestList = layout => {
  const requestList = [];
  const layoutList = [].concat(
    layout.left_block || [],
    layout.bottom_block || []
  );

  layoutList.forEach(e => {
    if (e.props && e.props.request && e.props.request.url)
      requestList.push(e.props.request);
  });

  return requestList.filter(e => e.url);
};

export const dataRequest = async function(
  state,
  request,
  comp,
  isEventLayer = false
) {
  const { type, url, mapping, plug, response } = request;

  if (plug) {
    state.$store.commit("ADD_SI_CENTER_LAYER_DATA", {
      data: response,
      layer_id: url,
      comp
    });
    state.$store.commit("ADD_SI_CENTER_COMPLETED_REQUEST", url);
    state.$store.commit("REMOVE_SI_CENTER_BAD_REQUEST", url);
  } else {
    try {
      let layerData;

      if (type === "hard") {
        layerData = await hardRequest(request);
      } else if (type === "events-2") {
        let res;
        try {
          const response = await fetch(url);
          const data = await response.json();
          res = [];
          Object.entries(data).forEach(([type, layer]) => {
            layer.forEach(item => {
              res.push({
                type,
                id: generateUUID(),
                ...item
              });
            });
          });

          layerData = res.map(item => {
            item.geom.coordinates = JSON.parse(item.geom.coordinates);
            if (item.geom.type === "Point") {
              item.geom.coordinates = item.geom.coordinates.reverse();
            } else if (item.geom.type === "LineString") {
              item.geom.coordinates = item.geom.coordinates.map(c => {
                return c.reverse();
              });
            }
            return item;
          });
          console.log(layerData);
          state.$store.commit("ADD_SI_CENTER_LAYER_DATA", {
            data: layerData,
            layer_id: url,
            comp
          });
          state.$store.commit("ADD_SI_CENTER_COMPLETED_REQUEST", url);
          state.$store.commit("REMOVE_SI_CENTER_BAD_REQUEST", url);
        } catch (e) {
          console.error(e);
        }
      } else {
        const filterUrl = state.$store.state.situationCenter.filterUrls[url];
        let { data } = await state.$store.dispatch("REQUEST", {
          url:
            type === "objectInfo"
              ? `objectInfo/${url}?config=${JSON.stringify(defaultConfig)}`
              : filterUrl
              ? filterUrl
              : url
        });

        if (url === "TagilPublicTransport?format=vehicles" && data === null) {
          data = [];
        }

        if (type === "statistic") {
          layerData = data;
        } else {
          layerData = updateDataItemsId(isEventLayer ? "events" : url, data);
        }

        const eventsClasses = this.$store.state.situationCenter.events.classes;

        if (isEventLayer) {
          layerData = layerData.map(e => {
            e.event_class_id = eventsClasses[e.event_class_id]
              ? eventsClasses[e.event_class_id].name
              : "Событие";
            return e;
          });
        }

        if (mapping) {
          layerData = requestMapping(layerData, mapping);
        }
      }

      state.$store.commit("ADD_SI_CENTER_LAYER_DATA", {
        data: layerData,
        layer_id: isEventLayer ? "events" : url,
        comp
      });
      state.$store.commit("ADD_SI_CENTER_COMPLETED_REQUEST", url);
      state.$store.commit("REMOVE_SI_CENTER_BAD_REQUEST", url);
    } catch (e) {
      console.log(e);
      state.$store.commit("ADD_SI_CENTER_BAD_REQUEST", url);
    }
  }
};

const hardRequest = async function(request) {
  const { url, geom } = request;

  try {
    const response = await fetch(url);
    const responseJson = await response.json();
    const data = [
      {
        id: "hard_cameras_lenobl",
        data: responseJson,
        geom
      }
    ];

    return data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

const updateDataItemsId = function(layer_id, data) {
  return Object.keys(data)
    .map(id => data[id])
    .map(e => {
      e.id = `${layer_id}?id:${e.id || e.created_at}`;
      return e;
    });
};
